import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-8" }
const _hoisted_2 = { class: "col-span-6" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import BranchesLayout from '../components/BranchesLayout.vue';
import PageLoader from "@/components/PageLoader.vue";
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import { useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import AuthService from '@/classes/AuthService';
import branch from "@/classes/Branch";
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const route = useRoute();
/**
 * ********************************
 * Data 
 * ********************************
 */
const loader           = ref(false);
const branchId         = ref(route.params.id as unknown as string);
const showError   = ref(false);
const errorMsg    = ref(false);
const errors      = ref([]);
const show        = ref(false);
const showSuccess = ref(false);
const form = ref({
    time_slot         : '',
})

const fetchData = async () => {
    try {
        loader.value = true;
        const response = await branch.editBranch(branchId.value)
        loader.value = false;
        Object.assign(form.value, response.data.branch)
    }
    catch(err: any) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response.data.message;

        if(err.response.status == 422) {
            errors.value = err.response.data.errors;
        }
    }
}

const submit = async () => {
    loader.value = true;
    const data = branch.formatData(form.value, branchId.value)

    try {
        await branch.updateTimeSlot(branchId.value, data)
        loader.value      = false;
        show.value        = false;
        showSuccess.value = true
                
        setTimeout(() => {
            window.location.replace('/branches')
        }, 2000);
    }
    catch(error: any) {
        show.value      = false;
        showError.value = true;
        errorMsg.value  = error.response.data.message;

        if(error.response.status == 422) {
            errors.value = error.response.data.errors;
        }
        errorResponse(error)
    }
}

const errorResponse = (err: any) => {
    loader.value = false

    if(err?.response.status == 401) {
        AuthService.redirectToLogin()
    }
}

const options = [
    { id: 15, label: '15 Minutes', value: 15 },
    { id: 30, label: '30 Minutes', value: 30 },
]


onMounted(() => {
    fetchData()    
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Block Date",
    "show-back": "",
    backUrl: `/branches/edit/${branchId.value}`
  }, {
    default: _withCtx(() => [
      _createVNode(BranchesLayout, { "branch-id": branchId.value }, {
        contents: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(FormSection, null, {
              title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" Booking Time Slot Duration Information ", -1)
              ]))]),
              description: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Relevant data and other details ", -1)
              ]))]),
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(MultiselectInput, {
                    label: "Booking Time Slot Duration",
                    placeholder: "Duration",
                    id: "time_duration",
                    name: "time_duration",
                    modelValue: form.value.time_slot,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.time_slot) = $event)),
                    options: options,
                    searchable: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clearProvince'))),
                    error: errors.value.time_slot ? errors.value.time_slot[0] : ''
                  }, null, 8, ["modelValue", "error"])
                ])
              ]),
              actions: _withCtx(() => [
                (_ctx.$hasPermission('set-booking-time-intervals'))
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      onClick: submit
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" Save Changes ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["branch-id"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[2] || (_cache[2] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Branch",
        content: "Branch Updated Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["backUrl"]))
}
}

})